import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../../../services/api';
import { PlannedFlightCreate, PlannedFlightUpdate } from '../../../types/api';
import { calendarKeys } from './calendar.queries';

// STD-015: write/imperative actions for the Calendar tab domain. Mutations
// do NOT invalidate the flights query because CalendarTab controls the visible
// date window via FullCalendar's onDatesSet; the component calls a local
// refetch (via query.refetch) after success. Errors are handled inline in the
// dialog so all mutations use skipGlobalErrorToast.

export function useCreatePlannedFlightMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (data: PlannedFlightCreate) => apiService.createPlannedFlight(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: calendarKeys.all });
    },
  });
}

export function useUpdatePlannedFlightMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: ({ id, data }: { id: string; data: PlannedFlightUpdate }) =>
      apiService.updatePlannedFlight(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: calendarKeys.all });
    },
  });
}

export function useDeletePlannedFlightMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (id: string) => apiService.deletePlannedFlight(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: calendarKeys.all });
    },
  });
}
